import { ApiCall } from '../../../services/http-service/types/ApiCall';
import httpService from '../../../services/http-service';
import { PANEL_NAME } from './enums/panel-name';
import { PanelPreferences } from './types/PanelPreferences';
import { UserPanelPreferences } from './types/UserPanelPreferences';
import { UserPreferencesData } from './types/UserPreferencesData';

export const getUserPreferences: ApiCall<undefined, UserPreferencesData> = async (config) => {
  const { data } = await httpService.get('/api/v3/user_preferences', null, config.abortSignal);
  return data;
};

export const setUserPreferences: ApiCall<Partial<UserPreferencesData>> = async ({ params, abortSignal }) => {
  return httpService.put('/api/v3/user_preferences', params, abortSignal);
};

export const setLocale: ApiCall<{ locale: string }> = ({ params }) => {
  return httpService.put('/api/v2/profile/update_locale', params);
};

export const getUserPanelPreferences: ApiCall<{ kind: PANEL_NAME }, UserPanelPreferences> = async ({ params, abortSignal }) => {
  const { data } = await httpService.get('/api/v3/account/users/user_panel_preferences', params, abortSignal);
  return data;
};

export const updateUserPanelPreferences: ApiCall<{ kind: PANEL_NAME; options: PanelPreferences }, UserPanelPreferences> = async ({ params, abortSignal }) => {
  const { data } = await httpService.put('/api/v3/account/users/user_panel_preferences', params, abortSignal);
  return data;
};